import React from 'react'
import { Route, Redirect } from 'react-router-dom'

// Redux
import { connect } from 'react-redux'

const PrivateRoute = ({ component: Component, layout: Layout, clientData, ...rest }) => {

    const { name, phone } = clientData.client

    return (
        <Route {...rest} render={props => (
            (!name || !phone)
                ? <Redirect to="." />
                : <Layout><Component {...props} /></Layout>
        )} />
    )
}

const mapStateToProps = (state) => {
    return {
        clientData: state.clientData
    }
}

export default connect(mapStateToProps)(PrivateRoute)